import * as React from 'react';
import { Avatar } from 'components';
import { thumbUrl } from 'helpers/common';
require('./style.css');

interface IProps {
	coverImageUrl?: string;
	imageUrl: string;
	onClick?: any;
}
/**
 *
 * @param props
 */
export const CardItemCoverImageWithAvatar = (props: IProps) => {
	const { coverImageUrl, imageUrl, onClick } = props;
	const onViewProfileClick = (e) => {
		if (onClick) {
			onClick(e);
		}
	};

	return (
		<div
			className="sectionItemProfileCover"
			style={{ backgroundImage: coverImageUrl ? `url(${thumbUrl(coverImageUrl)})` : '' }}
		>
			<div className="sectionItemProfileAvatarHolder">
				<Avatar imageUrl={imageUrl} onClick={(e) => onViewProfileClick(e)} />
			</div>
		</div>
	);
};
